module.exports = __webpack_public_path__ + "img/250460827_2025_2-2.e7eaf834.png";